import { useReducer, useRef, useCallback } from 'react'

export const INITIAL = {
  state: 'idle',
  sessionId: null,
  facts: {},
  extractedFacts: null,
  error: null,
}

function applyDelta(prev, delta) {
  const next = { ...prev }
  for (const [k, v] of Object.entries(delta?.sections || {})) {
    if (!Array.isArray(v) || v.length === 0) continue
    next[k] = [...(next[k] || []), ...v]
  }
  return next
}

export function sessionReducer(s, ev) {
  switch (ev.type) {
    case 'START':       return { ...s, state: 'starting', error: null }
    case 'STARTED':     return { ...s, state: 'recording', sessionId: ev.sessionId }
    case 'DELTA':       return { ...s, facts: applyDelta(s.facts, ev.delta) }
    case 'PAUSE':       return s.state === 'recording' ? { ...s, state: 'paused' } : s
    case 'RESUME':      return s.state === 'paused' ? { ...s, state: 'recording' } : s
    case 'STOP':        return { ...s, state: 'stopping' }
    case 'PROCESSING':  return { ...s, state: 'processing' }
    case 'READY':       return { ...s, state: 'ready', extractedFacts: ev.extractedFacts }
    case 'WS_LOST':     return s.state === 'recording' || s.state === 'paused' ? { ...s, state: 'degraded' } : s
    case 'WS_LOST_FINAL': return { ...s, state: 'interrupted' }
    case 'ERROR':       return { ...s, state: 'error', error: ev.message }
    case 'RESET':       return INITIAL
    default:            return s
  }
}

export function useSession() {
  const [s, dispatch] = useReducer(sessionReducer, INITIAL)
  const dispatchRef = useRef(dispatch)
  dispatchRef.current = dispatch
  const send = useCallback((ev) => dispatchRef.current(ev), [])
  return { ...s, send }
}
